var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_1068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 16.6667L14.3332 15.5L15.6457 14.1667H12.1665V12.5H15.6457L14.3332 11.1667L15.4998 10L18.8332 13.3333L15.4998 16.6667ZM3.83317 14.1667C3.37484 14.1667 2.98248 14.0035 2.65609 13.6771C2.3297 13.3507 2.1665 12.9583 2.1665 12.5V4.16667C2.1665 3.70833 2.3297 3.31597 2.65609 2.98958C2.98248 2.66319 3.37484 2.5 3.83317 2.5H14.6665C15.1248 2.5 15.5172 2.66319 15.8436 2.98958C16.17 3.31597 16.3332 3.70833 16.3332 4.16667V8.41667C16.1943 8.38889 16.0554 8.36806 15.9165 8.35417C15.7776 8.34028 15.6387 8.33333 15.4998 8.33333C15.3609 8.33333 15.2221 8.33681 15.0832 8.34375C14.9443 8.35069 14.8054 8.36806 14.6665 8.39583V5.33333L9.1665 9.16667L3.83317 5.35417V12.5H10.5623C10.5346 12.6389 10.5172 12.7778 10.5103 12.9167C10.5033 13.0556 10.4998 13.1944 10.4998 13.3333C10.4998 13.4722 10.5068 13.6111 10.5207 13.75C10.5346 13.8889 10.5554 14.0278 10.5832 14.1667H3.83317ZM5.0415 4.16667L9.1665 7.125L13.4165 4.16667H5.0415Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic-mail.7013c6463cfb92db610eabb93a88c820.svg";
export { ForwardRef as ReactComponent };